import { render, staticRenderFns } from "./renameFolder.html?vue&type=template&id=1810c5da&scoped=true&external"
import script from "./renameFolder.js?vue&type=script&lang=js&external"
export * from "./renameFolder.js?vue&type=script&lang=js&external"
import style0 from "./renameFolder.scss?vue&type=style&index=0&id=1810c5da&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810c5da",
  null
  
)

export default component.exports